import '@platform/index.css'
import { startApp } from '@core/utils/start-app'
import i18n, { i18nInit } from '@platform/i18n/i18n'
import { router } from '@platform/router'
import { ROUTES } from '@platform/router/paths'

startApp({
  router,
  i18n,
  i18nInit,
  sentryDsn: import.meta.env.VITE_PLATFORM_SENTRY_DSN,
  logOutPath: ROUTES.logOut,
  themeStorageKey: 'platform-ui-theme',
})
